import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Layout,
  theme,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  Checkbox,
  Spin,
  Col,
  InputNumber,
  Divider,
  DatePicker,
} from "antd";
import { useNavigate, Link } from "react-router-dom";

//PROJECT IMPORTS
import "../../../../assets/styles/DatePicker.css";
import MainLayout from "../../../../components/layouts/MainLayout";
import CustomButton from "../../../../components/custom/CustomButton";
import TopContent from "../../../../components/layouts/TopContent";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import {
  fxRateSetupAPI,
  fxRateSetupLabel,
  fxRateSetupStatic,
} from "../ManageFxRate.config";
import styles from "../../../../assets/styles/styles";

const { Text, Title } = Typography;

const NewPRD0602 = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;

  const navigate = useNavigate();
  const { newFxRateItems } = fxRateSetupStatic;
  const [form] = Form.useForm();
  const chargeApplyToCurrent = Form.useWatch("chargeAppliesTo", form);

  const dispatch = useDispatch();
  const [rateTypes, setRateTypes] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [active, setActive] = useState(false);

  useEffect(() => {
    getRateTypeTemplate();
    getCurrencyTemplate();
    //ACTIVATE SAVE RIGHTSIDEBAR ACTION
    // dispatch({
    //   type: cnt.RIGHT_SAVE_BTN,
    // });
  }, []);

  function getRateTypeTemplate() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, fxRateSetupAPI.FxRateTypes, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;
        let tempRateTypes = [];

        objList?.forEach((element) => {
          tempRateTypes.push({
            value: element.code,
            label: element.name,
          });
        });

        setRateTypes(tempRateTypes);
      }
    });
  }

  function getCurrencyTemplate() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, fxRateSetupAPI.Currencies, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;
        let tempCurrencies = [];

        objList?.currencyOptions?.forEach((element) => {
          tempCurrencies.push({
            value: element.code,
            label: element.displayLabel,
          });
        });

        setCurrencies(tempCurrencies);
      }
    });
  }

  const handleActiveChecked = (e) => {
    setActive(e.target.checked);
  };

  function onCancel() {
    navigate("/prd0602", { replace: false });
  }

  const onSubmit = (formValues) => {
    formValues.date = BOM.DateTime(formValues.date, "only-date");
    formValues.active = active;

    const body = {
      ...formValues,
      locale: "en",
      method: "POST",
      dateFormat: "dd MMMM yyyy",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, fxRateSetupAPI.FxRates, (err, res) => {
      if (err) {
        // BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, fxRateSetupLabel.newFxRateMsg);
        navigate("/prd0602");
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={fxRateSetupLabel.newFXRate}
        pageItems={newFxRateItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            initialValues={{
              active: true,
              isPenalty: false,
              // chargeAppliesTo: 2,
            }}
            form={form}
            layout="vertical"
            onFinish={onSubmit}
          >
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {fxRateSetupLabel.fxRateSetUp}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={fxRateSetupLabel.rateDate}
                  name="date"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(fxRateSetupLabel.rateDate),
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={BOM.handlePlaceholderMsg(
                      `${fxRateSetupLabel.rateDate} *`,
                      "select"
                    )}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={fxRateSetupLabel.currencyCode1}
                  name="fromCurrency"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(fxRateSetupLabel.currencyCode1),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${fxRateSetupLabel.currencyCode1} *`,
                      "select"
                    )}
                    options={currencies}
                    showSearch
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={fxRateSetupLabel.currencyCode2}
                  name="toCurrency"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(fxRateSetupLabel.currencyCode2),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${fxRateSetupLabel.currencyCode2} *`,
                      "select"
                    )}
                    options={currencies}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={fxRateSetupLabel.conversionType}
                  name="conversionType"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(fxRateSetupLabel.conversionType),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      fxRateSetupLabel.conversionType
                    )}
                    options={[
                      { id: 1, label: "Direct", value: "D" },
                      { id: 2, label: "InDirect", value: "I" },
                    ]}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={fxRateSetupLabel.conversionCurrency}
                  name="conversionCurrency"
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${fxRateSetupLabel.conversionCurrency}`,
                      "select"
                    )}
                    options={currencies}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={fxRateSetupLabel.rateType} name="rateType">
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${fxRateSetupLabel.rateType}`,
                      "select"
                    )}
                    options={rateTypes}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={fxRateSetupLabel.midRate}
                  name="midRate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(fxRateSetupLabel.midRate),
                    },
                  ]}
                >
                  <InputNumber
                    placeholder={BOM.handlePlaceholderMsg(
                      fxRateSetupLabel.midRate
                    )}
                    style={{ width: "100%" }}
                    formatter={BOM.FormatAmount}
                    parser={BOM.ParseAmount}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={fxRateSetupLabel.buyRate}
                  name="buyRate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(fxRateSetupLabel.buyRate),
                    },
                  ]}
                >
                  <InputNumber
                    placeholder={BOM.handlePlaceholderMsg(
                      fxRateSetupLabel.buyRate
                    )}
                    style={{ width: "100%" }}
                    formatter={BOM.FormatAmount}
                    parser={BOM.ParseAmount}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={fxRateSetupLabel.saleRate}
                  name="saleRate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(fxRateSetupLabel.saleRate),
                    },
                  ]}
                >
                  <InputNumber
                    placeholder={BOM.handlePlaceholderMsg(
                      fxRateSetupLabel.saleRate
                    )}
                    style={{ width: "100%" }}
                    formatter={BOM.FormatAmount}
                    parser={BOM.ParseAmount}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={fxRateSetupLabel.buySpread}
                  name="buySpread"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(fxRateSetupLabel.buySpread),
                    },
                  ]}
                >
                  <InputNumber
                    placeholder={BOM.handlePlaceholderMsg(
                      fxRateSetupLabel.buySpread
                    )}
                    style={{ width: "100%" }}
                    formatter={BOM.FormatAmount}
                    parser={BOM.ParseAmount}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={fxRateSetupLabel.saleSpread}
                  name="saleSpread"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(fxRateSetupLabel.saleSpread),
                    },
                  ]}
                >
                  <InputNumber
                    placeholder={BOM.handlePlaceholderMsg(
                      fxRateSetupLabel.saleSpread
                    )}
                    style={{ width: "100%" }}
                    formatter={BOM.FormatAmount}
                    parser={BOM.ParseAmount}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={fxRateSetupLabel.authStatus} name="status">
                  <Checkbox
                    placeholder={BOM.handlePlaceholderMsg(
                      `${fxRateSetupLabel.authStatus} *`,
                      "select"
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={fxRateSetupLabel.active}
                  name="active"
                  onChange={(e) => handleActiveChecked(e)}
                  checked={active}
                >
                  <Checkbox />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Divider />
              {BOM.HasPermission("CREATE_FX_RATE") && (
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />
              )}
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, null)(NewPRD0602);
